<ng-container>
	<div class="bg-body rounded">
		<div class="d-flex justify-content-between align-items-center fs-4 px-2">
			<label>Notatki</label>
			@if (editable()) {
				<button class="card__action" (click)="openNoteDialog(false)" mat-button>
					<i class="fas fa-plus-circle me-1"></i>
					<span> Dodaj notatkę</span>
				</button>
			}
		</div>
		<div
			[ngClass]="{
				'w-100': view() === 'summary',
				border: view() === 'summary',
				rounded: view() === 'summary',
			}"
		>
			@if (haveNotes) {
				<div>
					@for (item of visibleNotes(); track item.id) {
						<div>
							@if (view() === 'summary') {
								<div class="bg-notes m-2 rounded p-2">
									<div class="border-bottom border-2 d-flex justify-content-between py-1">
										<p class="m-0 align-self-center">
											{{ item.content }}
										</p>
										<div
											class="d-flex justify-content-center align-items-center noteAttachment"
											matTooltip="Ilość załączników"
										>
											{{ item.multimedia.length }}
										</div>
									</div>
									<div class="d-flex mb-1 mt-2 align-items-center">
										<div class="d-flex w-50 text-secondary">
											<div class="me-3">
												<i class="fas fa-user me-1"></i>{{ item.createdBy.firstName }}
												{{ item.createdBy.lastName }}
											</div>
											<div>
												<i class="fas fa-clock me-1"></i>{{ item.createdAt.date }} |
												{{ item.createdAt.time }}
											</div>
										</div>
										<div class="w-50 text-end">
											<button
												*ngIf="!item.hidden && editable()"
												class="me-2 edit-button"
												mat-raised-button
												(click)="openNoteDialog(item)"
												color="primary"
											>
												{{ checkEditTime(item) ? 'Edytuj' : 'Podgląd' }}
											</button>
											@if (!disableHiding()) {
												<button
													class="edit-button"
													(click)="hideOrShowNote(item, !item.hidden)"
													mat-raised-button
													color="primary"
												>
													@if (!item.hidden) {
														Ukryj
													} @else {
														Odkryj
													}
												</button>
											}
										</div>
									</div>
								</div>
							}
						</div>
					}
					@if (view() === 'tab') {
						<div>
							<table mat-table [dataSource]="convertedNoteList()" class="mat-elevation-z8 w-100">
								<ng-container matColumnDef="created">
									<th mat-header-cell *matHeaderCellDef>Utworzono</th>
									<td mat-cell *matCellDef="let element">
										{{ element.createdAt.date }}
										{{ element.createdAt.time }}
										{{ element.createdBy.firstName }}
										{{ element.createdBy.lastName }}
									</td>
								</ng-container>

								<ng-container matColumnDef="content">
									<th mat-header-cell *matHeaderCellDef>Treść</th>
									<td mat-cell *matCellDef="let element">
										{{ element.content }}
									</td>
								</ng-container>

								<ng-container matColumnDef="attachment">
									<th mat-header-cell *matHeaderCellDef>Liczba załączników</th>
									<td mat-cell *matCellDef="let element">
										{{ element.multimedia.length }}
									</td>
								</ng-container>

								<ng-container matColumnDef="kinds">
									<th mat-header-cell *matHeaderCellDef>Rodzaj notatki</th>
									<td mat-cell *matCellDef="let element">
										<span *ngFor="let kind of element.kinds; index as i"
											>{{ kind?.name
											}}<span *ngIf="element.kinds.length > 1 && element.kinds.length !== i + 1"
												>,
											</span></span
										>
									</td>
								</ng-container>

								<ng-container matColumnDef="edit">
									<th mat-header-cell *matHeaderCellDef></th>
									<td mat-cell *matCellDef="let element">
										<button
											*ngIf="!element.hidden || !checkEditTime(element)"
											class="edit-button"
											mat-raised-button
											(click)="openNoteDialog(element)"
											color="primary"
										>
											{{ checkEditTime(element) ? 'Edytuj' : 'Podgląd' }}
										</button>
									</td>
								</ng-container>

								<ng-container matColumnDef="hide">
									<th mat-header-cell *matHeaderCellDef></th>
									<td mat-cell *matCellDef="let element">
										@if (!disableHiding()) {
											<button
												class="edit-button"
												(click)="hideOrShowNote(element, !element.hidden)"
												mat-raised-button
												color="primary"
											>
												@if (!element.hidden) {
													Ukryj
												} @else {
													Odkryj
												}
											</button>
										}
									</td>
								</ng-container>

								<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
								<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
							</table>
						</div>
					}
				</div>
			} @else {
				<div class="bg-notes m-2 rounded p-2 text-center">
					Nie dodano jeszcze żadnych notatek lub wszystkie są ukryte
				</div>
			}
		</div>
	</div>
</ng-container>
